// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalLeaveWarning_basic-panel__i7H4t","title":"ModalLeaveWarning_title__JfOm2","text":"ModalLeaveWarning_text__gm9Ev"};